import classNames from 'classnames';
import React from 'react';
import { useCurationReview } from './state/CurationReviewContext';

const styles = require('./ProgressStrip.module.scss');

const PHASES = ['Eligibility checks', 'AI match & review', 'Decision'];

// Thin three-segment strip under the page header, mirroring the phase
// stepper: filled segments are completed or active phases.
export default function ProgressStrip() {
  const { state } = useCurationReview();

  const reached = state.submitted ? 3 : state.gateConfirmed ? 2 : 1;

  return (
    <div
      aria-label="Curation progress"
      aria-valuemax={PHASES.length}
      aria-valuemin={0}
      aria-valuenow={reached}
      className={styles['ui-progress-strip']}
      role="progressbar"
    >
      {PHASES.map((phase, index) => (
        <span
          aria-hidden
          className={classNames(styles['ui-progress-strip__segment'], {
            [styles['ui-progress-strip__segment--filled']]: index < reached,
          })}
          key={phase}
        />
      ))}
    </div>
  );
}
